import React, { useEffect, useState } from 'react';
import Tabs from '../components/Stats/Tabs';
import Overview from '../components/Stats/Overview';
import Players from '../components/Stats/Players';
import Teams from '../components/Stats/Teams';
import Standings from '../components/Stats/Standings';

const tabs = [
  {
    name: 'Översikt',
    path: '',
    component: Overview,
  },
  {
    name: 'Spelare',
    path: '/spelare',
    component: Players,
  },
  {
    name: 'Lag',
    path: '/lag',
    component: Teams,
  },
  {
    name: 'Tabell',
    path: '/tabell',
    component: Standings,
  },
];

function StatsPage() {
  const [contentToDisplay, setContentToDisplay] = useState(
    window.pageData.data.path || tabs[0].path
  );

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    history.pushState({}, '', `/statistik${contentToDisplay}`);
  }, [contentToDisplay]);

  const TabComponent =
    tabs.find((tab) => tab.path === contentToDisplay)?.component || Overview;

  return (
    <div className="row">
      <div className="col-12 col-xl-12">
        <div className="row px-3 px-md-3 mb-3 tabs-heading">
          <div className="col-12 col-md-7 d-flex align-items-center mb-4 mb-md-0 justify-content-center justify-content-md-start">
            <h1 className="heading-h3">Statistik</h1>
          </div>
        </div>
        <Tabs
          tabs={tabs}
          currentTab={contentToDisplay}
          switchContent={setContentToDisplay}
        />
        <TabComponent />
      </div>
    </div>
  );
}

export default StatsPage;
